import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export interface SPSyncGrantInfo {
    baseGrantNumber: string;
    grantNumber: string;
    shortInstitution: string | null;
}

export interface SPSyncRow {
    id: number;
    parentId: number | null;
    name: string;
    entityType: string;
    status: string;
    dB_EntityId: string | null;
    dB_SPId: string | null;
    dB_SPPath: string | null;
    sP_UniqueId: string | null;
    sP_Path: string | null;
    sP_FolderName: string | null;
    differences: string[];
    hasDiff: boolean;
}

export interface SPSyncResult {
    rows: SPSyncRow[];
    totalRows: number;
    matchCount: number;
    mismatchCount: number;
    dbOnlyCount: number;
    spOnlyCount: number;
    errors: string[];
}

export const getGrantList = async (fy: number): Promise<ApiResult<SPSyncGrantInfo[]>> => {
    return apiWrapperWithError<SPSyncGrantInfo[]>(`api/spsync/grants?fy=${fy}`, 'GET', `fetching grants for FY ${fy}`);
}

export const reconcile = async (fy: number, grantNumbers: string[]): Promise<ApiResult<SPSyncResult>> => {
    return apiWrapperWithError<SPSyncResult>(`api/spsync/reconcile`, 'POST', `reconciling SP sync for FY ${fy}`, { fy, grantNumbers });
}

export interface SPSyncGrantResult {
    grantNumber: string;
    fy: number;
    title: string;
    institution: string | null;
    result: SPSyncResult;
}

export const reconcileGrant = async (grantId: string): Promise<ApiResult<SPSyncGrantResult>> => {
    return apiWrapperWithError<SPSyncGrantResult>(`api/spsync/reconcile/${grantId}`, 'GET', `reconciling grant ${grantId}`);
}
